<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">

            <v-card class="flex pa-0 background-2 round-card">
			    <v-card-title class="pa-3">
    				<p class="pl-2 pl-xl-3">Giacenze</p>
                    <v-btn class="ml-1" icon text @click="showHelp = !showHelp">
                        <v-icon color="info">mdi-information-outline</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">							
                            <v-btn @click="downloadCsv()" v-on="on" icon>
                                <v-icon>get_app</v-icon>
                            </v-btn>
                        </template>
                        <span>Download</span>
                    </v-tooltip>
			    </v-card-title>
                <v-divider></v-divider>

                <v-alert
                    v-model="showHelp"
                    dismissible
                    dense
                    text
                    type="info"
                    icon="mdi-information-outline"
                    class="ma-3 mb-0 body-2"
                    @input="onHelpDismissed">
                    <div class="font-weight-medium mb-1">Come vengono calcolati i valori</div>
                    <div>
                        <strong>Giacenza</strong>: somma dei movimenti di magazzino del prodotto.
                    </div>
                    <div>
                        <strong>Costo Medio</strong>: media dei prezzi dei DDT di acquisto, ponderata sulle quantità.
                        La quota di giacenza che nessun DDT giustifica (giacenze iniziali, rettifiche di inventario,
                        trasferimenti fra magazzini) viene valorizzata al <strong>prezzo di acquisto dell'anagrafica prodotto</strong>.
                    </div>
                    <div>
                        <strong>Valore</strong>: giacenza × costo medio, azzerato se la giacenza è negativa.
                        <strong>Valore Magazzino Tot.</strong> è la somma dei valori di tutti i magazzini.
                    </div>
                    <div class="mt-2">
                        Esempio: 5 pezzi in giacenza, un DDT di acquisto per 3 pezzi a 10 € e anagrafica a 12 €
                        → (3 × 10) + (2 × 12) = <strong>54 €</strong> di valore, <strong>10,80 €</strong> di costo medio.
                    </div>
                    <div class="mt-2">
                        I filtri <strong>Data - Dal / Al</strong> limitano i movimenti considerati: restringendo il periodo
                        cambiano sia le giacenze sia i costi medi.
                    </div>
                </v-alert>

                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                    <fields-generator
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                    ></fields-generator>

			        <v-divider></v-divider>

                    <v-data-table
                        :items="items"
                        :headers="headers"
			            :options.sync="pagination"
			            :server-items-length="totalItems"
                        :loading="loading"
                        multi-sort
                        class="background-2 pb-0"
			            :mobile-breakpoint="0"
                        :footer-props="{
                            'items-per-page-options': [10, 25, 50, 100],
                            showFirstLastPage: true
                        }">
                        <template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
                            <tr class="cursor-pointer">
                                <template v-for="(header, h) in headers">
                                    <td v-if="header.type === 'currency'" :key="h" class="font-weight-bold">
                                        {{ item[header.value] | currency(header.decimals || 5) }}
                                    </td>
                                    <td v-else-if="header.type == 'date'" :key="h">
                                        {{ item[header.value] | date }}
                                    </td>
                                    <td v-else-if="typeof header.text_value !== 'undefined'" :key="h">
                                        {{ item[header.text_value] }}
                                    </td>
                                    <td v-else-if="header.type == 'chips'" :class="'text-xs-'+header.align" :key="h">
                                        <v-chip v-for="(chip, c) in JSON.parse(item[header.value])" small :key="c">{{ chip }}</v-chip>
                                    </td>
                                    <td v-else :key="h">
                                        {{ item[header.value] }}
                                    </td>
                                </template>
                            </tr>
                        </template>
                        <!-- Riga dei totali: presente solo se il backend ha restituito
                        column_totals. Una td per header, senza colspan, cosi' le celle
                        restano allineate alle colonne -->
                        <template v-slot:body.append="{ headers }">
                            <tr v-if="hasColumnTotalsRow" class="column-totals-row font-weight-bold">
                                <template v-for="(header, h) in headers">
                                    <td v-if="h === 0" :key="'total-' + h" class="text-no-wrap">Totale</td>
                                    <td v-else :key="'total-' + h" :class="header.class" class="text-no-wrap">
                                        <template v-if="columnTotalValue(header) !== undefined">
                                            {{ columnTotalValue(header) | currency(header.decimals || 2) }}
                                        </template>
                                    </td>
                                </template>
                            </tr>
                        </template>
                        <template v-slot:footer.page-text="{ pageStart, pageStop }">
                            Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>

    export default {
        name: 'stock',
        data() {
            return {
                model: {},
				items: [],
                headers: [],
                fieldsset: {},
                totalItems: 0,
                pagination: {},
				loading: false,
                filtered: false,
                datepicker_menu: {},
                showHelp: true,
                // Totali di colonna sull'intero set filtrato, dalla chiave
                // column_totals della paginazione
                columnTotals: null,
                totalsSignature: null
            }
        },

        computed: {
            // La riga totali compare solo se il backend ha calcolato almeno un
            // totale per una colonna visibile
            hasColumnTotalsRow() {
                if(!this.columnTotals) return false
                return this.headers.some(header => this.columnTotalValue(header) !== undefined)
            }
        },

        watch: {
            model: {
                handler() {
                    this.getData()
                },
                deep: true,
            },

			pagination: {
				handler: function(newValue, oldValue) {
                    if (newValue.page !== oldValue.page || 
                        newValue.itemsPerPage !== oldValue.itemsPerPage || 
                        newValue.sortBy !== oldValue.sortBy || 
                        newValue.sortDesc !== oldValue.sortDesc) {
                        this.getData()
                    }
				},
				deep: true,
			},            
        },

        methods: {

            onHelpDismissed(value) {
                if(!value) localStorage.setItem('stocks_help_dismissed', '1')
            },

            // Valore della riga totali per una colonna: definito solo per le
            // colonne flaggate con total nei fieldDefs. I null del backend
            // restano celle vuote, non 0
            columnTotalValue(header) {
                if(!this.columnTotals || !header.total) return undefined
                const value = this.columnTotals[header.key || header.value]
                return value === null || value === '' ? undefined : value
            },

            getData() {
                this.loading = 'warning'

                // I totali costano una query aggregata sull'intero set: si
                // richiedono solo quando cambiano i filtri, non a ogni cambio
                // di pagina o ordinamento
                const totalsSignature = JSON.stringify(this.model)
                const withTotals = totalsSignature !== this.totalsSignature

                let dataObject = {
                    page: this.pagination.page,
                    per_page: this.pagination.itemsPerPage,
                    sortBy: this.pagination.sortBy,
                    sortDesc: this.pagination.sortDesc,
                    filters: this.model,
                    with_totals: withTotals,
                }
                this.axios.post('stocks-filters', dataObject).then(response => {
                    this.items = response.data.data.data
                    this.totalItems = response.data.data.total
                    if(withTotals) {
                        this.columnTotals = response.data.data.column_totals || null
                        this.totalsSignature = totalsSignature
                    }
                    this.loading = false

                }, response => {
                    // error callback
                })
            },

            selectChange(event) {
                if(this.$store.getters.checkModulePermissions('banci') && event && event.key == 'product_id') {
                    this.axios.get('products/' + this.model.product_id).then(response => {
                        this.colors = response.data.model.colors
                    }, response => {
                        // error callback
                    })
                } else {
                    this.colors = []
                    this.model.colors = []
                }
            },

            downloadCsv() {
                this.$eventBusUtility.openFile(this.$store, '/stocks-downloadcsv/', 'giacenze.csv', 'POST', { filters: this.model })
            }
        },
        
        created() {
            this.showHelp = localStorage.getItem('stocks_help_dismissed') !== '1'

            this.axios.get('stocks-info').then(response => {
                // get body data
                this.fieldsset = response.data.fields
                this.headers = response.data.info.fieldDefs

                this.$store.commit('endProgress')

            }, response => {
                // error callback
            })
        },
    }
</script>

<style scoped>
    /* Riga dei totali: sticky in fondo all'area di scroll della tabella, cosi'
    resta visibile anche prima di arrivare a fine scroll orizzontale. Stessi
    colori del fixed-header (il tema non genera le custom properties) */
    .v-data-table > .v-data-table__wrapper > table > tbody > tr.column-totals-row > td {
        position: sticky;
        bottom: 0;
        z-index: 2;
        background-color: #FFFFFF;
        border-top: thin solid rgba(0, 0, 0, 0.12);
    }

    .theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr.column-totals-row > td {
        background-color: #424242;
        border-top-color: rgba(255, 255, 255, 0.12);
    }
</style>
